import { useStaticQuery, graphql } from "gatsby";

const RecipeLandingQuery = () => {
  const recipeLandingData = useStaticQuery(graphql`
    query RecipeLandingData {
      sanityRecipeLandingPage {
        hero {
          ...sanityHero
        }
        additionalHeros {
          ...sanityHero
        }
        seo {
          ...sanitySeo
        }
      }
    }
  `);

  return recipeLandingData;
};

export default RecipeLandingQuery;
